/**
 * gameTokens — split from `data.ts`'s legacy `PACKS` array into its own
 * module (narcis file-split shape), plan `thinking/plans/2026_08_31_toile_pack_wiring.md` Track A,
 * script `generation/scripts/packs/toile_split_data.py`.
 */
import {SQUARE, tagline, chips, type ToilePack} from './data'

export const gameTokensPack: ToilePack = {
    slug: 'game-tokens',
    category: 'tokens',
    name: 'Game tokens',
    tagline: tagline('tokens', 'creatures', 'styles'),
    chips: chips('creatures', 'styles'),
    ratio: SQUARE,
    readings: [
        {key: 'goblin', label: 'Goblin', subject: 'a goblin skirmisher with a notched dagger and a leather hood'},
        {key: 'knight', label: 'Knight', subject: 'a knight in plate armor, a raised visor and a crimson surcoat'},
        {key: 'wolf', label: 'Dire wolf', subject: 'a dire wolf with matted grey fur, yellow eyes and bared fangs'},
    ],
    styles: [
        {key: 'ring', label: 'Painted ring', style: 'a painted portrait inside an ornate riveted metal ring', palette: 'dramatic side lighting, rich paint', framing: 'circular token, head and shoulders'},
        {key: 'emblem', label: 'Flat emblem', style: 'bold silhouette shapes reduced to two tones', palette: 'a solid disc with a thin contrasting rim', framing: 'circular token, head and shoulders'},
        {key: 'ink', label: 'Gritty ink', style: 'harsh cross-hatching and heavy spot blacks', palette: 'black ink, one blood-red accent', framing: 'circular token on a torn-paper disc'},
    ],
    directions: ['an orc chieftain instead', 'in green and bronze', 'fiercer, mid-snarl'],
}
